import { pxToRem } from '../../../../lib';
export default (function () {
  return {
    // GAP VALUES
    'gap.smaller': pxToRem(8),
    'gap.small': pxToRem(10),
    'gap.medium': pxToRem(15),
    'gap.large': pxToRem(30),
    // PADDING VALUES
    'padding.medium': pxToRem(10)
  };
});